import { init } from "@rematch/core";
import selectPlugin from "@rematch/select";
import loadingPlugin from "@rematch/loading";
import { connectRouter, routerMiddleware } from "connected-react-router";
import logger from "redux-logger";

export const createStore = (history, models) =>
  init({
    redux: {
      reducers: { router: connectRouter(history) },
      middlewares: [routerMiddleware(history), logger],
      devtoolOptions: {},
    },
    models,
    plugins: [loadingPlugin(), selectPlugin()],
  });
